import { 
    // 批量設定上架列表
    apiBizGetBatchPublishList,
    //批量設定上架
    apiBizUpdateBatchPublish,
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'batchPublish/set_checkbox_status',
    set_batch_publish_list: 'batchPublish/set_batch_publish_list',
    set_selected_house: 'batchPublish/set_selected_house',
    set_filter_query: 'batchPublish/set_filter_query',
    set_success_list: 'batchPublish/set_success_list',
}

// count state 必須是 Object
const state = {
    bizBatchPublishList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedHouse: [],
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: []

}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BATCH_PUBLISH_LIST: (state) => {
        return state.bizBatchPublishList
    },
    GET_BIZ_BATCH_PUBLISH_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_BATCH_PUBLISH_LIST_TOTAL: (state) => {
        return state.bizBatchPublishList.length
    },
    GET_BIZ_BATCH_PUBLISH_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_BATCH_PUBLISH_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedHouse.length?true:false
    },
    GET_BIZ_BATCH_PUBLISH_SELECTED_HOUSE_CID: (state) => {
        return state.selectedHouse
    },
    GET_BIZ_BATCH_PUBLISH_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BATCH_PUBLISH_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizBatchPublishList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetBatchPublishList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let batchPublish = res.data.result
                    commit(types.set_batch_publish_list, batchPublish)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizBatchPublish ( {commit, dispatch, getters} ) {
        return new Promise((resolve, reject) => {
            let data = getters.GET_BIZ_BATCH_PUBLISH_SELECTED_HOUSE_CID
            apiBizUpdateBatchPublish(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchPublishList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizBatchPublishCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setBizBatchPublishSeletedHouse ( {commit}, data ) {
        commit(types.set_selected_house, data)
    },
    setBizBatchPublishFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setSuccessFlag ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouse = data
    },
    [types.set_batch_publish_list](state, data){
        state.bizBatchPublishList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state){
        state.successList = state.selectedHouse
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseMgt/batchPublish.js